import PropTypes from "prop-types";
import React, { Component } from "react";
import { Trans } from "@lingui/macro";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  Button,
  Dialog,
  FormGroup,
  TextField,
  withStyles
} from "@material-ui/core";
import { validPriorityCode } from "../utils/fetcher";
import { connect } from "react-redux";

const styles = () => ({
  dialog: {
    borderRadius: "15px"
  }
});

class PriorityCode extends Component {
  state = {
    open: false,
    input1Ref: React.createRef(),
    input2Ref: React.createRef(),
    input3Ref: React.createRef(),
    input4Ref: React.createRef(),
    input5Ref: React.createRef(),
    input6Ref: React.createRef(),
    isChange: true
  };

  handleClickOpen = e => {
    e.preventDefault();
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleChange = input => {
    this.setState({ isChange: !this.state.isChange });
    if (input) {
      input.current.focus();
    }
  };

  isDisabled = () => {
    return (
      !this.state.input1Ref.current ||
      this.state.input1Ref.current.value === "" ||
      (!this.state.input2Ref.current ||
        this.state.input2Ref.current.value === "") ||
      (!this.state.input3Ref.current ||
        this.state.input3Ref.current.value === "") ||
      (!this.state.input4Ref.current ||
        this.state.input4Ref.current.value === "") ||
      (!this.state.input5Ref.current ||
        this.state.input5Ref.current.value === "") ||
      (!this.state.input6Ref.current ||
        this.state.input6Ref.current.value === "")
    );
  };

  handleSubmit = e => {
    e.preventDefault();
    const code =
      this.state.input1Ref.current.value +
      this.state.input2Ref.current.value +
      this.state.input3Ref.current.value +
      this.state.input4Ref.current.value +
      this.state.input5Ref.current.value +
      this.state.input6Ref.current.value;
    this.props.validPriorityCode(code);
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        {!this.props.isShow && (
          <button
            onClick={this.handleClickOpen}
            className="custom-link no-style-btn"
            color="primary"
          >
            <Trans id="W_STEP1_BAS_CODE_PRIORITAIRE" />
          </button>
        )}
        <Dialog
          aria-labelledby="priority-dialog-title"
          open={this.props.isShow ? true : this.state.open}
          onClose={this.handleClose}
          classes={{
            paper: classes.dialog
          }}
        >
          <DialogTitle className="head-dialog" id="priority-dialog-title">
            <div className="title-dialog">
              <i className="material-icons">warning</i>
              <span className="title-text">
                <Trans id="W_STEP1_POPUP_CODE_CODE_PRIORITAIRE" />
              </span>
            </div>
            <button className="btn-back" onClick={this.handleClose}>
              <i className="material-icons white">close</i>
            </button>
          </DialogTitle>
          <div className="body-dialog">
            <form className="form-priority-code" onSubmit={this.handleSubmit}>
              {this.props.message && (
                <div
                  className="text-error align-center"
                  dangerouslySetInnerHTML={{ __html: this.props.message }}
                />
              )}
              <label
                htmlFor="priority-code"
                className="text color-font-main-md"
              >
                <Trans id="W_STEP1_POPUP_CODE_ENTRER_CODE_TRANSMIS_PAR_VOTRE_PRATICIEN" />
              </label>

              <FormGroup className="wrap-inputs-code">
                <TextField
                  margin="normal"
                  required={true}
                  inputProps={{
                    maxLength: 1
                  }}
                  className="input-code"
                  onChange={e => this.handleChange(this.state.input2Ref, e)}
                  autoFocus={true}
                  inputRef={this.state.input1Ref}
                />
                <TextField
                  margin="normal"
                  className="input-code"
                  required={true}
                  inputProps={{
                    maxLength: 1
                  }}
                  onChange={e => this.handleChange(this.state.input3Ref, e)}
                  inputRef={this.state.input2Ref}
                />
                <TextField
                  margin="normal"
                  required={true}
                  inputProps={{
                    maxLength: 1
                  }}
                  className="input-code"
                  onChange={e => this.handleChange(this.state.input4Ref, e)}
                  inputRef={this.state.input3Ref}
                />
                <TextField
                  margin="normal"
                  required={true}
                  inputProps={{
                    maxLength: 1
                  }}
                  className="input-code"
                  onChange={e => this.handleChange(this.state.input5Ref, e)}
                  inputRef={this.state.input4Ref}
                />
                <TextField
                  margin="normal"
                  required={true}
                  inputProps={{
                    maxLength: 1
                  }}
                  className="input-code"
                  onChange={e => this.handleChange(this.state.input6Ref, e)}
                  inputRef={this.state.input5Ref}
                />
                <TextField
                  margin="normal"
                  required={true}
                  inputProps={{
                    maxLength: 1
                  }}
                  className="input-code"
                  inputRef={this.state.input6Ref}
                  onChange={e => this.handleChange(null, e)}
                />
              </FormGroup>

              <Button
                variant="contained"
                className="btn-filled"
                color="primary"
                disabled={this.isDisabled()}
                type="submit"
              >
                <Trans id="W_VALIDER" />
              </Button>
            </form>
          </div>
        </Dialog>
      </div>
    );
  }
}

PriorityCode.propTypes = {
  classes: PropTypes.shape({
    dialog: PropTypes.any
  }),
  isShow: PropTypes.bool,
  message: PropTypes.any,
  validPriorityCode: PropTypes.func
};

const mapStateToProps = state => {
  return {
    message: state.message
  };
};

const mapDispatchToProps = dispatch => {
  return {
    validPriorityCode: code => dispatch(validPriorityCode(code))
  };
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PriorityCode)
);
